// extracted by mini-css-extract-plugin
export var createdDate = "_ix-1";
export var divider = "_ix-2";
export var headerDivider = "_ix-3";
export var messagesCard = "_ix-0";
export var messagesContainer = "_ix-6";
export var messagesContainerWrapper = "_ix-4";
export var showLeftPanelButton = "_ix-8";
export var topButtons = "_ix-7";
export var withPadding = "_ix-5";